export default __webpack_public_path__ + "static/media/IconImage.147208da.svg";